const extractResponseText = value => {
  if (value === null || value === undefined) return value;
  if (typeof value !== 'object') return value;

  return value.content || value.suggestion || value.text || value.message || '';
};

export const normalizeAiResponseText = text => {
  const responseText = extractResponseText(text);
  if (responseText === null || responseText === undefined) return responseText;

  const normalized = String(responseText)
    .replace(/\r\n?/g, '\n')
    .split('\n')
    .map(line => line.trimEnd())
    .join('\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();

  const lines = normalized.split('\n');
  const nonEmptyLines = lines.filter(line => line.trim());
  if (nonEmptyLines.length < 4) return normalized;

  const singleLineBlocks = normalized
    .split(/\n{2,}/)
    .every(block => block.split('\n').length === 1);
  const repeatedBlankSeparators =
    (normalized.match(/\n[ \t]*\n/g) || []).length >= 3;

  if (!singleLineBlocks || !repeatedBlankSeparators) return normalized;

  return nonEmptyLines.map(line => line.trim()).join('\n');
};
